import { render, staticRenderFns } from "./PendingZohoCustomer.vue?vue&type=template&id=2cc79a97&"
import script from "./PendingZohoCustomer.vue?vue&type=script&lang=js&"
export * from "./PendingZohoCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports